import script from "./LayoutCatracas.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutCatracas.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__